import { render, staticRenderFns } from "./oferta-public.vue?vue&type=template&id=90df3b68&scoped=true"
import script from "./oferta-public.vue?vue&type=script&lang=js"
export * from "./oferta-public.vue?vue&type=script&lang=js"
import style0 from "./oferta-public.vue?vue&type=style&index=0&id=90df3b68&prod&lang=css"
import style1 from "./oferta-public.vue?vue&type=style&index=1&id=90df3b68&prod&scoped=true&lang=css"
import style2 from "./oferta-public.vue?vue&type=style&index=2&id=90df3b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90df3b68",
  null
  
)

export default component.exports